
<mat-dialog-content>

    <mat-card class="login-page">
        <mat-card-title>Login</mat-card-title>
        <mat-card-content>


            <form class="login-form data-form"
                  #loginForm="ngForm"
                  (ngSubmit)="loginFromForm(loginForm)">

                <mat-form-field>

                    <input matInput
                           ngModel
                           required
                           minlength="3"
                           type="text"
                           name="username"
                           placeholder="Username"
                           #username="ngModel" />

                    <!-- @if(username.errors?.["required"]){ <mat-error>Username is required</mat-error>} -->

                </mat-form-field>

                <mat-form-field>

                    <input matInput
                           ngModel
                           required
                           passwordStrength
                           type="password"
                           name="password"
                           placeholder="Password" />
                    <!-- #password="ngModel"> -->
                    <!-- @if(password.errors?.["required"]){ <mat-error>Password is required</mat-error>} -->

                </mat-form-field>

                <button mat-raised-button color="primary" type="submit">
                    <!--  [disabled]="!loginForm.valid"> -->
                    Login
                </button>
                @if(loginError){<div class="errorMessage"> <mat-error>Incorrect Login</mat-error></div>}
            </form>
            <!--<div class="form-val">
                {{loginForm.value | json}}
            </div>-->
        </mat-card-content>
    </mat-card>

</mat-dialog-content>
